export const VERIFICATION_STATUS = {
  READY: "ready",
  REQUEST: "request",
  COMPLETE: "complete",
};
